import React, { useEffect, useState } from "react";
import Internal_Audit_Form from "./internal_Audit_Form/Internal_Audit_Form";
import Internal_Audit_table from "./internal_Audit_table/Internal_Audit_table";
import Edit_Internal_Audit from "./edit_Internal_Audit/Edit_Internal_Audit";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/management_system/Slice";
import { useDispatch, useSelector } from "react-redux";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FixIDS } from "../../../../../../utils/fixIDS";

function Internal_Audit({ managementdetails, setCurrentPage, currentPage }) {
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleEdit = (id) => {
    setEditId(id);
    setIsEdit(true);
  };

  const permissions = useSelector((state) => state.auth.permissions);
  const haveAddPermission = permissions?.includes(FixIDS.internal_audit.Add);
  const haveReadPermission = permissions?.includes(FixIDS.management_system.List);

  return (
    <section className="Imperiality">
      {isEdit ? (
        <>
          <div className="back_div">
            {/* <Common_Back_Btn backText="Edit Internal audit" /> */}
          </div>
          <Edit_Internal_Audit
            id={editId}
            managementsystemTypeId={1}
            onCancel={() => {
              setIsEdit(false);
              setEditId(null);
            }}
          />
        </>
      ) : (
        <>
          <div className="imperiality_Form_div">
            {haveAddPermission && (
              <Internal_Audit_Form managementsystemTypeId={1} />
            )}
          </div>

          <div className="imperiality_table_div">
            {haveReadPermission && (
              <Internal_Audit_table
                managementsystemTypeId={1}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                managementdetails={managementdetails}
                onEdit={handleEdit}
              />
            )}
          </div>
        </>
      )}
    </section>
  );
}

export default Internal_Audit;
